import { jws } from 'jsrsasign';
const tokenEndpointUrl = `${__myapp.env.COGNITO_DOMAIN_URL}/oauth2/token`;
const apiBaseUrl = __myapp.env.REQUESTS_BASE_URL;

const acquireTokenFromCodeQueryParameter = async () => {
    const parsedSearchQuery = new URLSearchParams(window.location.search);

    const code = parsedSearchQuery.get('code');

    if (code) {
        const tokenRequestData = new URLSearchParams({
            code,
            client_id: __myapp.env.COGNITO_CLIENT_ID,
            client_secret: __myapp.env.COGNITO_CLIENT_SECRET,
            redirect_uri: window.location.origin,
            grant_type: 'authorization_code',
        });

        const tokenRequestHeaders = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
        });

        const response = await fetch(tokenEndpointUrl, {
            method: 'POST',
            headers: tokenRequestHeaders,
            body: tokenRequestData,
        });

        if (!response.ok) {
            throw new Error('Provided code parameter is invalid');
        }

        const token = await response.json();

        if (token.error) {
            throw new Error('Provided code parameter is invalid');
        }

        return token;
    }

    throw new Error('Code parameter does not exist in search query');
};

const loadTokens = () => ({
    accessToken: sessionStorage.getItem('access_token'),
    refreshToken: sessionStorage.getItem('refresh_token'),
});

const saveTokens = ({ accessToken, refreshToken }) => {
    sessionStorage.setItem('access_token', accessToken);
    sessionStorage.setItem('refresh_token', refreshToken);
};

const clearTokens = () => {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
};


const acquireNewAccessToken = async (refreshToken) => {
    const tokenRequestData = new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        client_id: __myapp.env.COGNITO_CLIENT_ID,
    });

    const tokenRequestHeaders = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
    });

    const response = await fetch(tokenEndpointUrl, {
        method: 'POST',
        headers: tokenRequestHeaders,
        body: tokenRequestData,
    });

    if (!response.ok) {
        throw new Error('Invalid refresh token provided');
    }

    const token = await response.json();

    if (token.error) {
        throw new Error('Invalid refresh token provided');
    }

    return token;
};

export const handleTokenAuthorization = async () => {
    const {
        accessToken: storedAccessToken,
        refreshToken: storedRefreshToken,
    } = loadTokens();

    if (storedAccessToken && storedRefreshToken) {
        const isAccessTokenValid = await checkToken(storedAccessToken);

        if (isAccessTokenValid !== 204) {
            const {
                access_token: accessToken,
            } = await acquireNewAccessToken(storedRefreshToken);

            saveTokens({
                accessToken,
                refreshToken: storedRefreshToken,
            });
        }
    } else {
        const {
            access_token: accessToken,
            refresh_token: refreshToken,
        } = await acquireTokenFromCodeQueryParameter();

        saveTokens({
            accessToken,
            refreshToken,
        });
    };

    sessionStorage.getItem('access_token')
};

const redirectToEndpoint = (endpoint) => {
    const hostedUiParams = new URLSearchParams({
        client_id: __myapp.env.COGNITO_CLIENT_ID,
        client_secret: __myapp.env.COGNITO_CLIENT_SECRET,
        response_type: 'code',
        scope: __myapp.env.COGNITO_SCOPE,
        redirect_uri: window.location.origin,
    }).toString();

    const hostedUiUrl = `${__myapp.env.COGNITO_DOMAIN_URL}/${endpoint}?${hostedUiParams}`;

    console.log(hostedUiParams);
    window.location.assign(
        hostedUiUrl,
    );
};

export const redirectToLoginPage = () => {
    redirectToEndpoint('login');
};

export const logoutAndRedirect = () => {
    clearTokens();
    redirectToEndpoint('logout');
};

export const getAccessToken = async () => {
    const {
        accessToken,
        refreshToken,
    } = loadTokens();

    try {
        if (!accessToken) {
            throw new Error('Access token does not exist');
        }

        if (isTokenExpired(accessToken)) {
            const {
                access_token: newAccessToken,
            } = await acquireNewAccessToken(refreshToken);

            saveTokens({
                accessToken: newAccessToken,
                refreshToken,
            });

            return newAccessToken;
        }

        return accessToken;
    } catch {
        return null;
    }
};

const isTokenExpired = (accessToken) => {
    const { payloadObj } = jws.JWS.parse(accessToken);

    const tokenExpirationTimestamp = payloadObj.exp;

    const currentDate = new Date();

    const currentUnixTimestampInSeconds = Math.floor(currentDate.getTime() / 1000);

    return currentUnixTimestampInSeconds > tokenExpirationTimestamp;
};

const checkToken = async (token) => {
    const response = await fetch(`${apiBaseUrl}/logged/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        console.log(response);
    }

    return response.status;
};